// removed by extract-text-webpack-plugin
module.exports = {"ItemCard":"_1cauweOQcdhJ7UZfLJiAf1","CompletedCard":"IGfwDa8g2-dmFSIAEfLFl","CardLink":"_7NH6BHUPXzAWivxgnDF0a","CardHeader":"_16Z01NFZnvkfCSPhKusqse","Lecturer":"-KIUNZLjH0UO_9In_7TbX","RatingContainer":"_1FjFfVHzbliP01xS-BAaMH","CardFooter":"wosjfokp7ONXaipEgvIeq","CourseItem":"_3BHfaUzVnPwGgL6uUDtGCZ","UOC":"_1JVmvC9l5kIwYwGb27TPbk","ContactHours":"_3QG2DCH5iwPzLwjygCSOi6","GenEd":"_1GE4ZVMHOpVOcNRG4LLKKA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Course/CourseCard.css
// module id = 1188
// module chunks = 0